import type {
  EntityRequiredSubmittal,
  TextAndDocument,
} from '@abb-procure/data';

export type IdLike = {
  id: number;
  getDisplay(): string | null;
};

export const isSameSelect = (
  left?: IdLike | null,
  right?: IdLike | null,
): boolean => {
  if (!left && !right) {
    return true;
  }

  if (!left || !right) {
    return false;
  }

  return left.id === right.id;
};

export const isSameSelectMulti = (
  a?: IdLike | null,
  b?: IdLike | null,
  c?: IdLike | null,
): boolean => isSameSelect(a, b) && isSameSelect(a, c);

export const isSameTextAndDocument = (
  left?: TextAndDocument,
  right?: TextAndDocument,
): boolean => {
  if (!left && !right) {
    return true;
  }

  if (!left || !right) {
    return false;
  }

  const textEquals = (left.text ?? '') === (right.text ?? '');

  const documentsEquals =
    left.documents.length === right.documents.length &&
    left.documents.every((document) =>
      right.documents.some(
        (rightDocument) =>
          rightDocument.fileName === document.fileName &&
          rightDocument.fileSize === document.fileSize,
      ),
    ) &&
    right.documents.every((document) =>
      left.documents.some(
        (leftDocument) =>
          leftDocument.fileName === document.fileName &&
          leftDocument.fileSize === document.fileSize,
      ),
    );

  return textEquals && documentsEquals;
};

export const isSameTextAndDocumentMulti = (
  a?: TextAndDocument,
  b?: TextAndDocument,
  c?: TextAndDocument,
): boolean => isSameTextAndDocument(a, b) && isSameTextAndDocument(a, c);

export const isSameRequiredSubmittals = (
  left?: EntityRequiredSubmittal[] | null,
  right?: EntityRequiredSubmittal[] | null,
): boolean => {
  if (!left && !right) {
    return true;
  }

  if (!left || !right) {
    return false;
  }

  const submittalsEquals =
    left.length === right.length &&
    left.every((submittal, index) => {
      const sameName = submittal.name === right[index].name;
      const sameValue = submittal.isChecked === right[index].isChecked;
      const sameComment =
        (submittal.comment ?? '') === (right[index].comment ?? '');

      return sameName && sameValue && sameComment;
    });

  return submittalsEquals;
};

export const isSameRequiredSubmittalsMulti = (
  a?: EntityRequiredSubmittal[] | null,
  b?: EntityRequiredSubmittal[] | null,
  c?: EntityRequiredSubmittal[] | null,
): boolean => isSameRequiredSubmittals(a, b) && isSameRequiredSubmittals(a, c);
